import { render, staticRenderFns } from "./addProductDialogStep2.vue?vue&type=template&id=81cff0a0&scoped=true&"
import script from "./addProductDialogStep2.vue?vue&type=script&lang=js&"
export * from "./addProductDialogStep2.vue?vue&type=script&lang=js&"
import style0 from "./addProductDialogStep2.vue?vue&type=style&index=0&id=81cff0a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cff0a0",
  null
  
)

export default component.exports